import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/relatorio-alto-custo-estatistico-cid`

    return {
        cid: {
            autocomplete(queryParms = {}) {

                return repository.get(`${baseUrl}/autocomplete-cid?${urlUtil.serialize(queryParms)}`)
            },
        },
        index(queryParms) {

            return repository.get(`${baseUrl}?${urlUtil.serialize(queryParms)}`)
        },
        list(queryParms) {

            return repository.get(`${baseUrl}/list?${urlUtil.serialize(queryParms)}`)
        },
    }
}